document.addEventListener("DOMContentLoaded", function () {
  const loadMoreBtn = document.querySelector("[data-load-more]");
  const productList = document.querySelector("[data-products-list]");
  const progressText = document.querySelector(".pagination-wrapper__progress-bar--txt");
  const progressBar = document.querySelector(".pagination-wrapper__progress-bar--current");

  if (!loadMoreBtn || !productList) return;

  loadMoreBtn.addEventListener("click", function (e) {
    e.preventDefault();

    const nextUrl = loadMoreBtn.getAttribute("href");
    if (!nextUrl) return;

    // Add loading state
    loadMoreBtn.classList.add("loading");

    fetch(nextUrl)
      .then(response => response.text())
      .then(data => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(data, "text/html");

        // Extract new products and append
        const newItems = doc.querySelector("[data-products-list]");
        if (newItems) {
          productList.insertAdjacentHTML("beforeend", newItems.innerHTML);
        } else {
          console.warn("No new product items found in next page.");
        }

        // Update progress bar text
        const newText = doc.querySelector(".pagination-wrapper__progress-bar--txt");
        if (newText && progressText) {
          progressText.innerHTML = newText.innerHTML;
        } else {
          // Fallback: calculate manually
          const loadedCount = productList.children.length;
          progressText.innerHTML = `Showing ${loadedCount} of ${loadedCount} products`;
          if (progressBar) {
            progressBar.style.width = "100%";
          }
        }

        // Update progress bar width if available
        const newProgress = doc.querySelector(".pagination-wrapper__progress-bar--current");
        if (newProgress && progressBar) {
          progressBar.style.width = newProgress.style.width;
        }

        // Update or remove the load more button
        const newLoadMore = doc.querySelector("[data-load-more]");
        if (newLoadMore && newLoadMore.getAttribute("href")) {
          loadMoreBtn.setAttribute("href", newLoadMore.getAttribute("href"));
        } else {
          loadMoreBtn.remove(); // No more pages
        }

        loadMoreBtn.classList.remove("loading");
      })
      .catch(err => {
        console.error("Load more failed:", err);
        loadMoreBtn.classList.remove("loading");
      });
  });
});
